import { Component, OnInit } from '@angular/core';
import { AuthService }      from '../auth.service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';

import { Observable }         from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  email: string;
  password: string;
  message: string;

  constructor(public authService: AuthService, public router: Router, private route: ActivatedRoute) {

  }

  login() {
    this.authService.login(this.email,this.password).subscribe((result)=>{
      console.log("callback",result)
      if(result.status == "success"){
        if(this.redirect != "undefined"){this.redirect = ""};
        this.router.navigate(['/'+this.redirect]);
      } else if(result.status == "error"){
        if(result.result == "You must include credentials to use this auth method."){
          this.message = "You must include an email and password"
        } else if(result.result.code == "auth/wrong-password"){
          this.message = "You have entered an incorrect password"
        } else {
          this.message = "You have entered incorrect details please try again"
        }
      }
    })
  }

  redirect: string;
  ngOnInit() {
    this.redirect = this.route.queryParams['_value']['redirect'];
    console.log("ngOnInit")
    /*this.af.auth.subscribe((auth) =>{
      if(auth != null) {
        this.router.navigate(['/']);
      }
    })*/
  }

}



// WEBPACK FOOTER //
// /Users/jackwoodward/Desktop/JCW Services/Huckleberry Partners/Hoxby Internal Projects/intranet/hoxbyHub/src/app/login/login.component.ts